module.exports = __webpack_public_path__ + "static/media/editor.e28e42fe.png";